<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <notifications></notifications> -->

    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            img: require('../../assets/img/Overview.png'),
            path: '/dashboard',
          }"
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: $t('sidebar.cluster'),
            img: require('../../assets/img/Cluster.png'),
          }"
        >
          <sidebar-item
            :link="{ name: $t('sidebar.listcluster'), path: '/listcluster' }"
          ></sidebar-item>
        </sidebar-item>
<!-- 
        <sidebar-item
          :link="{
            name: $t('sidebar.feederpillar'),
            img: require('../../assets/img/Feeder Pillar.png'),
          }"
        > -->
          <!-- <div  @click="renderComponent()"> -->
          <!-- <sidebar-item
            @click="renderComponent()"
            v-for="item in fp"
            :key="item.index"
            :link="{
              name: item.fpname,
              path: '/listfeederpillar/' + item.fpid,
            }"
          ></sidebar-item> -->
          <!-- </div> -->
        <!-- </sidebar-item> -->

        <!-- list of cluster -->
        <sidebar-item
          :link="{ name: $t('sidebar.feederpillar'),
          icon: 'tim-icons icon-image-02' }"
        >
          <!-- <sidebar-item :link="{ name: $t('sidebar.listfeederpillar'), path: '/listfp' }"></sidebar-item> -->
        <!-- <sidebar-item v-for="item in fp" :key="item.index" :link="{ name: item.fpname, path: '/listfeederpillar', props: item.fpid}">
            
          </sidebar-item> -->
        <!-- <ul>
            <li class="nav-link" v-for="item in fp" :key="item.index" @click="passID(item.fpid)">
              {{item.fpname}}
            </li>
          </ul> -->
        </sidebar-item>

        <!-- Multi Level -->
        <sidebar-item
          :link="{
            name: $t('sidebar.management'),
            img: require('../../assets/img/Admin.png'),
          }"
        >
          <sidebar-item
            v-if="isAdmin == true"
            :link="{ name: $t('sidebar.usermanagement'), path: '/admin/user' }"
          ></sidebar-item>
          <sidebar-item
            v-if="
              isAdmin == true ||
              isDeviceCreate == true ||
              isDeviceDelete == true
            "
            :link="{
              name: $t('sidebar.devicemanagement'),
              path: '/admin/device',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="
              isAdmin == true ||
              isDeviceCreate == true ||
              isDeviceDelete == true
            "
            :link="{
              name: $t('sidebar.gatewaymanagement'),
              path: '/admin/gateway',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="
              isAdmin == true ||
              isClusterCreate == true ||
              isClusterDelete == true
            "
            :link="{
              name: $t('sidebar.clustermanagement'),
              path: '/admin/clustermanagement',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="
              isAdmin == true ||
              isClusterCreate == true ||
              isClusterDelete == true
            "
            :link="{
              name: $t('sidebar.feederpillarmanagement'),
              path: '/admin/feederpillar',
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="
            isAdmin == true ||
            isDeviceView == true ||
            isDeviceDelete == true ||
            isClusterView == true
          "
          :link="{
            name: $t('sidebar.scheduler'),
            img: require('../../assets/img/Schedule.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.clusterscheduler'),
              path: '/clusterscheduler',
            }"
          ></sidebar-item>

          <!-- <sidebar-item :link="{ name: $t('sidebar.setholidays'), path: '/setholidays' }"></sidebar-item> -->
        </sidebar-item>
        <sidebar-item
          :link="{
            name: $t('sidebar.operation'),
            img: require('../../assets/img/operator.png'),
          }"
        >
          <sidebar-item
            :link="{
              name: $t('sidebar.operationoverview'),
              path: '/operation',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('sidebar.wo'), path: '/ticketstatus/all' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('sidebar.performance'), path: '/performance' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('sidebar.report'), path: '/report' }"
          ></sidebar-item>

          <!-- <sidebar-item :link="{ name: $t('sidebar.setholidays'), path: '/setholidays' }"></sidebar-item> -->
        </sidebar-item>

        <!-- <sidebar-item
          v-if="isAdmin == true || isDeviceView == true || isDeviceDelete == true || isClusterView == true"
          :link="{ name: $t('sidebar.eventmanagement'),
          icon: 'tim-icons icon-image-02' }"
        >
          <sidebar-item :link="{ name: $t('sidebar.eventnotify'), path: '/event/notifymanagement' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('sidebar.eventtrail'), path: '/event/trailmanagement' }"></sidebar-item>

        </sidebar-item> -->
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <!-- <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share> -->
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <modal :show.sync="modals.noti" type="medium" :showClose="false" :centered="center" :clickToClose="clickclose">
      <template slot="header">
        <h3 class="modal-title" id="exampleModalLabel">
          <i
            class="tim-icons icon-bell-55 text-success"
            style="font-size: 20px"
          ></i>
          New Notification
        </h3>
      </template>
      <div class="text-left">
        <p class="text-left" v-for="item in wonoti" :key="item.id"> 
          There is a status change on the work order {{ item.woid }}. <base-button class="btn btn-link" @click="open(item.woid)">Click here to see more.</base-button>
        </p>
      </div>
    </modal>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import SidebarShare from "./SidebarSharePlugin";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import SidebarFixedToggleButton from "./SidebarFixedToggleButton.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
import { Modal } from "src/components";
import { Message } from 'element-ui';
export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
    Modal,
    [Message.name]: Message
  },
  data() {
    return {
      sidebarBackground: "vue", // vue|blue|orange|green|red|primary,
      roleScope: [],
      isAdmin: false,
      isDeviceView: false,
      isDeviceCreate: false,
      isDeviceDelete: false,
      isClusterView: false,
      isClusterCreate: false,
      isClusterDelete: false,
      center:true,
      clickclose:true,
      fp: [],
      modals: {
        noti: false,
      },
      wonoti: [],
      interval: null
    };
  },
  methods: {

    renderComponent() {
     
    },
    getToken() {
      // let jwt_token = sessionStorage.getItem("token").split(".")[1];
      let jwt_token = this.$cookie.get("token").split(".")[1];
    
      let user_scope = JSON.parse(atob(jwt_token));
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");

      // initScrollbar("sidebar");
      // initScrollbar("main-panel");
      // initScrollbar("sidebar-wrapper");
      // docClasses.add("perfect-scrollbar-on");

      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        initScrollbar("sidebar");
        initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");
        docClasses.add("perfect-scrollbar-on");
      }
    },
    getFeederPillar() {
      this.fp = [];
      this.$http.get(":8002/api/v1/manage/feeder").then((res) => {
        if (!res.error) {
          let response = res.message;
        

          for (var i = 0; i < response.length; i++) {
            let obj = {
              index: i,
              fpname: response[i].fp_name,
              fpid: response[i].fp_id,
            };
            this.fp.push(obj);
          }
        }
      });
    },
    getNoti() {
      this.modals.noti = false;
      this.$http.get(`:8002/api/v1/work-order/notification`).then((res) => {
        if (!res.error) {
          let response = res.message;
         

          this.wonoti = [];
          for (var i = 0; i < response.length; i++) {
            // let workorderid = response[i].WorkOrderID;
            let obj = {
              id: i + 1,
              woid: response[i].WorkOrderID,
            };
            this.wonoti.push(obj);
            this.modals.noti = true;

            // this.notifyVue(
            //   "bottom",
            //   "right",
            //   workorderid
            // );
         
            // if (document.URL.includes("ticketstatus.vue")) {
            //   this.modals.noti = false;
            // } else {
             
            // }
          }
        }
      });
    },
    open(woid){
      this.modals.noti = false
      this.$router.push({ path: "/ticketstatus/" + woid });
    }
    // notifyVue(verticalAlign, horizontalAlign, workorderid) {
    //   this.$notify({
    //     title: "New Notification",
    //     message:
    //       "There is a status change on the work order " +
    //       workorderid +
    //       ". Click here to see more.",
    //     timeout: 3000,
    //     icon: "tim-icons icon-bell-55",
    //     horizontalAlign: horizontalAlign,
    //     verticalAlign: verticalAlign,
    //     type: "success",
    //     onClick: () => {
    //       this.$router.push({ path: "/ticketstatus/" + workorderid });
    //     },
    //   });
    // },
  },
  watch: {
    wonoti: {
      handler: function (val, oldVal) {
      
        if (this.wonoti.length == 0) {
          this.modals.noti = false;
        } else {
          this.modals.noti = true;
        }
      },
    },
    $route() {
      if (this.$route.name == "Work Order Status") {
     
        
        this.modals.noti = false;
        clearInterval(this.interval);
      } else {
      
        // this.$message({
        //   showClose: true,
        //   message: "assaaaaaa",
        //   type: "warning",
        // });
       
        this.interval = setInterval(() => {
          this.getNoti();
        }, 60000);
      }
    },
  },
  mounted() {
    // let jwt_token = sessionStorage.getItem("token").split(".")[1];
    let jwt_token = this.$cookie.get("token").split(".")[1];
    jwt_token = JSON.parse(atob(jwt_token));
    let user_scope = jwt_token["UserScopes"];
    for (let i = 0; i < user_scope.length; i++) {
      this.roleScope.push(user_scope[i]);
      for (let j = 0; j < this.roleScope.length; j++) {
        // view for admin
        if (this.roleScope[j] === "admin.view") {
          this.isAdmin = true;
        }
        // view to control device management
        if (this.roleScope[j] === "device.view") {
          this.isDeviceView = true;
        }
        // view to control device cluster
        if (this.roleScope[j] === "device.create") {
          this.isDeviceCreate = true;
        }
        if (this.roleScope[j] === "device.delete") {
          this.isDeviceDelete = true;
        }
        if (this.roleScope[j] === "cluster.view") {
          this.isClusterView = true;
        }
        if (this.roleScope[j] === "cluster.create") {
          this.isClusterCreate = true;
        }
        if (this.roleScope[j] === "cluster.delete") {
          this.isClusterDelete = true;
        }
      }
    }
    sessionStorage.setItem("accessList", JSON.stringify(this.roleScope));
 
    this.initScrollbar();
  },
  created() {
    this.getFeederPillar();
    this.getNoti()
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
